import { render, staticRenderFns } from "./HighlightView.vue?vue&type=template&id=37faa405&"
import script from "./HighlightView.vue?vue&type=script&lang=js&"
export * from "./HighlightView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports